<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>Payment Transaction Details</strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row dense justify="center">
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="status" :items="status_list"
                        item-text="name" return-object label="Type" outlined persistent-hint hint="Select Type" />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-text-field label="Enter Id" v-model="id" color="#0F2027" dense outlined rounded></v-text-field>
                </v-col>
                <v-col sm="2">
                    <v-btn rounded class="button mt-6" v-if="id && status" @click="getAllReport()"
                        :loading="loader">Fetch</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-card class="box" v-if="payment_history != ''">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Payment Transaction Details</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-toolbar flat dense color="white">
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                </v-text-field>
            </v-toolbar><br>
            <center style="color: red;"><b>Note : If you click on 'Check Status', you need to generate receipt manually
                    !!</b></center><br>
            <v-data-table :headers="headers" :items="payment_history" class="elevation-1 mytable" dense
                :search="search">
                <template v-slot:item.save="{ item }">
                    <v-btn :disabled="item.check_status == 'NO'" small rounded @click="generateReceipt(item)"
                        class="button">
                        Check Status
                    </v-btn>
                    <!-- {{item.check_status}} -->
                </template>
                <template v-slot:item.paymenttransactionstatus="{ item }">
                    <v-select v-model="item.paymenttransactionstatus" :items="payment_status_list" item-text="name"
                        item-value="name" dense outlined rounded hide-details label="Payment Status"
                        style="min-width: 180px;"></v-select>
                </template>
                <template v-slot:item.status="{ item }">
                    <v-text-field v-model="item.status" dense outlined rounded hide-details label="Status"
                        style="min-width: 180px;"></v-text-field>
                </template>
                <template v-slot:item.update_status="{ item }">
                    <v-btn small rounded class="button" @click="updateStatus(item)">
                        Update Status
                    </v-btn>
                </template>
            </v-data-table>
        </v-card>
        <v-overlay :value="loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data() {
        return {
            loader: false,
            color: "",
            snackbar: false,
            search: "",
            snackbar_msg: null,
            status_list: [
                { name: "Order Id", id: "0" },
                { name: "Transaction Id", id: "1" },
            ],
            payment_status_list: [],
            payment_history: [],
            // extraBreadcrumbItems: [


            // ],
            // breadcrumbClass: "breadcrumb-style1",
            status: null,
            id: null,
            headers: [
                {
                    text: "Sr. No.",
                    align: "left",
                    sortable: false,
                    value: "srno",
                },
                {
                    text: "Learner",
                    align: "left",
                    sortable: false,
                    value: "learner",
                },
                {
                    text: "Amount",
                    align: "left",
                    sortable: false,
                    value: "amount",
                },
                {
                    text: "Paid For",
                    align: "left",
                    sortable: false,
                    value: "purpose",
                },
                {
                    text: "Order Id",
                    align: "left",
                    sortable: true,
                    value: "order_id",
                },
                {
                    text: "Transaction Id",
                    align: "left",
                    sortable: true,
                    value: "trxn_id",
                },
                {
                    text: "JSON Pre Transaction Data",
                    align: "left",
                    sortable: true,
                    value: "json_pre_trans_data",
                },
                {
                    text: "Purpose",
                    align: "left",
                    sortable: true,
                    value: "purpose",
                },
                {
                    text: "Pg Response",
                    align: "left",
                    sortable: true,
                    value: "pg_response",
                },
                {
                    text: "Pg Response Status API",
                    align: "left",
                    sortable: true,
                    value: "pg_response_status_api",
                },
                {
                    text: "Response Code",
                    align: "left",
                    sortable: true,
                    value: "response_code",
                },
                {
                    text: "Response MSG",
                    align: "left",
                    sortable: true,
                    value: "response_msg",
                },
                { text: "Transaction Date", value: "transaction_date", sortable: false },
                { text: "Payment Mode", value: "mode", sortable: false },
                { text: "Payment Status", value: "paymenttransactionstatus", sortable: false },
                { text: "Status", value: "status", sortable: false },
                { text: "Update Status", value: "update_status", sortable: false },
                { text: "Check Status", value: "save", sortable: false },
            ],
        };
    },

    methods: {
        generateReceipt(item) {
            axios
                .post("/AccountingAndFees/checkStatus", item)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", res.data.smsg);
                        this.getAllReport()
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);

                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => { });
        },
        getAllReport() {
            const data = {
                id: this.id,
                status: this.status
            }
            this.loader = true
            axios
                .post("/AccountingAndFees/getTransactionDeatils", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.payment_history = res.data.payment_history;
                        this.payment_status_list = res.data.payment_mode.filter(
                            item => item.name !== "All"
                        );
                        this.loader = false
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.smsg);
                        this.loader = false
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.loader = false
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => { });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        updateStatus(item) {
            this.loader = true;

            axios
                .post("/AccountingAndFees/updateTransactionStatus", {
                    id: item.id,
                    paymenttransactionstatus: item.paymenttransactionstatus,
                    status: item.status
                })
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", res.data.smsg);
                        this.getAllReport();
                    } else {
                        this.showSnackbar(
                            "#b71c1c",
                            res.data.smsg || "Something went wrong!!!"
                        );

                        if (res.data.error_trace) {
                            sessionStorage.setItem(
                                "error-trace",
                                res.data.error_trace
                            );
                        }
                    }
                })
                .catch((error) => {
                    this.showSnackbar(
                        "#b71c1c",
                        "Something went wrong..."
                    );
                })
                .finally(() => {
                    this.loader = false;
                });
        },
    },
    mounted() {
    },
};
</script>
<style scoped></style>
